import {
  ANNUALLY,
  FISCAL_YTD,
  MONTHLY,
  PERIOD_TYPES_STRING,
  PREPARATION_TYPE_ANALYST_KEY,
  PREPARATION_TYPE_CPA_PREP_KEY,
  PREPARATION_TYPE_MANAGEMENT_KEY,
  PREPARATION_TYPE_NTR_KEY,
  PREPARATION_TYPE_QUALIFIED_KEY,
  PREPARATION_TYPE_REVIEWED_KEY,
  PREPARATION_TYPE_TAX_RETURN_KEY,
  PREPARATION_TYPE_UNKNOWN_KEY,
  PREPARATION_TYPE_UNQUALIFIED_KEY,
  PREPARATION_TYPES_FOR_HISTORICAL,
  PREPARATION_TYPES_FOR_PROJECTIONS,
  QUARTERLY,
  SCENARIO_TYPE_HISTORICAL,
  SCENARIO_TYPE_PROFORMA,
  SCENARIO_TYPE_PROJECTION,
  SEMI_ANNUALLY,
} from '@utils/constants';

const periodLabels = PERIOD_TYPES_STRING as Record<string, string>;

const scenarioLabels: Record<string, string> = {
  [SCENARIO_TYPE_HISTORICAL]: 'Historical',
  [SCENARIO_TYPE_PROJECTION]: 'Projection',
  [SCENARIO_TYPE_PROFORMA]: 'Proforma',
};

/** Labels for column `preparationType` (merge of historical + projection maps from constants). */
export const preparationTypeDisplayByKey: Record<string, string> = {
  ...PREPARATION_TYPES_FOR_PROJECTIONS,
  ...PREPARATION_TYPES_FOR_HISTORICAL,
};

/** Spreading reporting header select: same order/labels as {@link PERIOD_TYPES_STRING} (no TTM). */
export const reportingIntervalHeaderOptions: ReadonlyArray<{ value: string; label: string }> = (
  [MONTHLY, QUARTERLY, SEMI_ANNUALLY, ANNUALLY, FISCAL_YTD] as const
).map((value) => ({ value, label: PERIOD_TYPES_STRING[value] }));

export const scenarioHeaderOptions: ReadonlyArray<{ value: string; label: string }> = [
  { value: SCENARIO_TYPE_HISTORICAL, label: scenarioLabels[SCENARIO_TYPE_HISTORICAL] },
  { value: SCENARIO_TYPE_PROJECTION, label: scenarioLabels[SCENARIO_TYPE_PROJECTION] },
];

/** Preparation select key order for historical columns (matches prior spreading header). */
export const preparationTypeHistoricalHeaderKeys: readonly string[] = [
  PREPARATION_TYPE_UNKNOWN_KEY,
  PREPARATION_TYPE_UNQUALIFIED_KEY,
  PREPARATION_TYPE_QUALIFIED_KEY,
  PREPARATION_TYPE_TAX_RETURN_KEY,
  PREPARATION_TYPE_REVIEWED_KEY,
  PREPARATION_TYPE_CPA_PREP_KEY,
  PREPARATION_TYPE_NTR_KEY,
  PREPARATION_TYPE_MANAGEMENT_KEY,
];

export const preparationTypeProjectionHeaderKeys: readonly string[] = [
  PREPARATION_TYPE_MANAGEMENT_KEY,
  PREPARATION_TYPE_CPA_PREP_KEY,
  PREPARATION_TYPE_ANALYST_KEY,
];

function isBlank(value: string | null | undefined): boolean {
  return value == null || String(value).trim() === '';
}

export function reportingIntervalDisplay(value: string | null | undefined): string {
  if (isBlank(value)) {
    return '';
  }
  return periodLabels[value] ?? value;
}

export function scenarioDisplay(value: string | null | undefined): string {
  if (isBlank(value)) {
    return '';
  }
  return scenarioLabels[value] ?? value;
}

export function preparationTypeDisplay(value: string | null | undefined): string {
  if (isBlank(value)) {
    return '';
  }
  return preparationTypeDisplayByKey[value] ?? value;
}
